<div class="sign-in-container">
  <div class="sign-in-box">
    <div class="logo">
      <img src="assets/logopurplenwhite.svg" alt="KnockVia" class="logo-img" />
    </div>

    <div *ngIf="systemMessages.length > 0" class="system-messages">
      <div class="system-messages__header">
        <span class="badge">System</span>
        <span class="title">Updates</span>
      </div>
      <div *ngFor="let message of systemMessages; trackBy: trackByMessage" class="system-message">
        <div class="system-message__icon">!</div>
        <p class="system-message__text">{{ message.message }}</p>
      </div>
    </div>

    <div *ngIf="successMessage" class="success-message">{{ successMessage }}</div>
    <div *ngIf="error" class="error-message">{{ error }}</div>

    <form *ngIf="!otpSent" [formGroup]="loginForm">
      <nz-tabset (nzSelectChange)="tabChanged($event)">
        <nz-tab nzTitle="Phone">
          <div>
            <div class="form-group">
              <label for="phone" class="subtitle">Phone Number</label>
              <input nz-input id="phone" formControlName="phone" type="tel" placeholder="1234567890" maxlength="11"
                pattern="^(1\d{10}|\d{10})$" (input)="stripFirstDigit($event)" />
              <div
                *ngIf="loginForm.get('phone')?.invalid && (loginForm.get('phone')?.dirty || loginForm.get('phone')?.touched)"
                class="error-message">
                <p *ngIf="loginForm.get('phone')?.errors?.['required']">Phone number is required.</p>
                <p *ngIf="loginForm.get('phone')?.errors?.['pattern']">Please enter a valid 10-digit phone number.</p>
              </div>
            </div>
          </div>
        </nz-tab>
        <nz-tab nzTitle="Email">
          <div>
            <div class="form-group">
              <label for="email" class="subtitle">Email</label>
              <input nz-input id="email" formControlName="email" placeholder="email@email.com" />
              <div
                *ngIf="loginForm.get('email')?.invalid && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)"
                class="error-message">
                <p *ngIf="loginForm.get('email')?.errors?.['required']">Email is required.</p>
              </div>
            </div>
          </div>
        </nz-tab>
      </nz-tabset>
    </form>

    <button *ngIf="!otpSent" nz-button nzType="primary" nzBlock (click)="sendOtp()" class="sign-in-btn"
      [nzLoading]="isSendingOtp">
      {{ isSendingOtp ? 'Sending OTP...' : 'Send OTP' }}
    </button>

    <form *ngIf="otpSent" [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
      <div class="form-group">
        <label for="otp" class="subtitle">Enter OTP</label>
        <input nz-input id="otp" formControlName="otp" type="text" placeholder="Enter OTP" />
      </div>
      <button type="submit" nz-button nzType="primary" nzBlock class="sign-in-btn" [disabled]="otpForm.invalid"
        [nzLoading]="isVerifyingOtp">
        {{ isVerifyingOtp ? 'Verifying OTP...' : 'Verify OTP' }}
      </button>
    </form>
  </div>

  <div *ngIf="isLoading" class="sign-in-loading-backdrop">
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
    <p>{{ loadingMessage || 'Please wait...' }}</p>
  </div>
</div>